export default {
  "content": "<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M12.5 3a2 2 0 012 2v5.5H17a1 1 0 011 1v3.25a.75.75 0 001.5 0V7.618l-1.447-.723.894-1.79 2 1A1 1 0 0121.5 7v7.75a2.75 2.75 0 11-5.5 0V12.5h-1.5V19h7v2h-18a1 1 0 01-1-1V5a2 2 0 012-2h8zm-8 16h8V5h-8v14z\" fill=\"#7B61FF\"/>",
  "attrs": {
    "width": "24",
    "height": "24",
    "viewBox": "0 0 24 24",
    "fill": "none",
    "xmlns": "http://www.w3.org/2000/svg"
  }
};